import { ClientFlags } from '@sdk/authentication/types';
import { useClientFlags } from '@sdk/session/ClientFlagsContext';

import { accessAngularRootScope } from '@web/integrations/accessAngularRootScope';

export const useWebClientFlags = () => {
  const { updateClientFlags: update } = useClientFlags();
  const { ngEmit } = accessAngularRootScope();

  const updateClientFlags = (clientFlags: Partial<ClientFlags>) => {
    update(clientFlags);

    ngEmit('sdk:client-flags:save', clientFlags);
  };

  return { updateClientFlags };
};
